// Module
var code = "<md-content flex layout=\"column\" layout-fill cg-busy=\"vm.promise\">\n    <mn-prescription-item mn-type=\"{{ ::vm.type }}\" mn-item=\"vm.prescription\" mn-unique></mn-prescription-item>\n</md-content>\n";
// Exports
module.exports = code;